import React from 'react';

import './css/index.scss';

class AccountSettings extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
    };
  }

  render () {
    return (
      <div className="homeContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-100px'}}>
            <h1>Setări Cont</h1>
            <p>în curând</p>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountSettings;



// WEBPACK FOOTER //
// ./src/components/accountSettings/accountSettings.js